export default {
      id: "twitter-usage",
      viewBox: "0 0 455.731 455.731",
      url: __webpack_public_path__ + "./images/icons.svg#twitter",
      toString: function () {
        return this.url;
      }
    }